import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(circle at top right, #ffffff 0%, #f4f7f6 100%);
  padding: 20px;
`;

export const ValidationCard = styled.div`
  width: 100%;
  max-width: 500px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(15px);
  padding: 40px;
  border-radius: 24px;
  border: 1px solid rgba(177, 125, 42, 0.1);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);
  animation: ${fadeIn} 0.5s ease-out;
  text-align: center;

  h2 {
    margin-bottom: 30px;
    background: linear-gradient(135deg, #d4af37 0%, #b17d2a 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 800;
  }
`;

export const SelectType = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 25px;

  button {
    flex: 1;
    padding: 12px;
    border-radius: 12px;
    border: 1px solid #ddd;
    background: white;
    cursor: pointer;
    font-weight: 700;
    transition: all 0.3s;

    &.active {
      background: linear-gradient(135deg, #d4af37 0%, #b17d2a 100%);
      color: white;
      border-color: transparent;
    }
  }
`;

export const InputGroup = styled.div`
  margin-bottom: 25px;
  text-align: left;

  label {
    display: block;
    font-size: 13px;
    font-weight: 700;
    color: #666;
    margin-bottom: 8px;
  }

  input {
    width: 100%;
    padding: 15px;
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 16px;
    transition: 0.3s;

    &:focus {
      outline: none;
      border-color: #b17d2a;
      box-shadow: 0 0 0 3px rgba(177, 125, 42, 0.1);
    }
  }
`;

export const ActionButton = styled.button`
  width: 100%;
  padding: 15px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #d4af37 0%, #b17d2a 100%);
  color: white;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(177, 125, 42, 0.2);
  }

  &:disabled {
    filter: grayscale(1);
    cursor: not-allowed;
  }
`;

export const ResultBox = styled.div`
  margin-top: 30px;
  padding: 20px;
  border-radius: 12px;
  background: ${(props) => (props.success ? "#e8f5e9" : "#ffebee")};
  border: 1px solid ${(props) => (props.success ? "#2e7d32" : "#c62828")};
  color: ${(props) => (props.success ? "#1b5e20" : "#b71c1c")};
  font-size: 14px;
  text-align: left;
  line-height: 1.6;

  pre {
    margin-top: 10px;
    white-space: pre-wrap;
    font-family: inherit;
  }
`;
